import React from "react";
import { profileRoutes, routesLimited } from "./routes";

import { AppRouterLimited } from "../shared/components/AppRouter";

export const ProfileRoutes = () => (
  <AppRouterLimited routes={profileRoutes} routesLimited={routesLimited} />
);
